// extracted by mini-css-extract-plugin
export var container = "_db-0";
export var icon = "_db-1";
export var text = "_db-2";